// src/pages/RedirectAfterLogin.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { redirectToLogin } from "./utils/authRedirect";

const apiUrl = process.env.REACT_APP_API_URL;

const RedirectAfterLogin = () => {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();

  useEffect(() => {
    let isActive = true;

    const syncOnboardingAnswers = async () => {
      try {
        const raw = localStorage.getItem("onboardingAnswers");
        if (!raw) return;

        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== "object") return;

        const response = await fetch(`${apiUrl}/user/onboarding-answers`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify(parsed),
        });

        if (response.ok) {
          localStorage.removeItem("onboardingAnswers");
        }
      } catch (error) {
        // Ignore syncing issues and continue redirect flow.
      }
    };

    const validateSession = async () => {
      const authenticatedUser = await checkAuth();

      if (!isActive) {
        return;
      }

      if (authenticatedUser) {
        await syncOnboardingAnswers();
        navigate("/functionalpagelogin", { replace: true });
        return;
      }

      redirectToLogin();
    };

    validateSession();

    return () => {
      isActive = false;
    };
  }, [navigate]);

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", color: "#666" }}>
      Se finalizeaza autentificarea...
    </div>
  );
};

export default RedirectAfterLogin;
